import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import { ADD_NOTIFICATION } from "../store/action";
import { connect } from "react-redux";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(4, 0),
    },
    container: {
        maxWidth: theme.maxContentWidth,
        margin: '0 auto',
        padding: theme.spacing(0, 2),
    },
    title: {
        marginBottom: theme.spacing(4),
        textAlign: 'center',
    },
    form: {
        marginTop: theme.spacing(4),
    },
    formContainer: {
        padding: theme.spacing(3),
    },
    submitButton: {
        marginTop: theme.spacing(2),
    },
    contactInfo: {
        marginTop: theme.spacing(4),
    },
    contactItem: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing(2),
    },
    contactIcon: {
        marginRight: theme.spacing(2),
        color: theme.palette.primary.main,
    },
    paper: {
        padding: theme.spacing(3),
        height: '100%',
    },
}));

const ContactUs = ({ dispatch }) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Box className={classes.root}>
            <Container className={classes.container}>
                <Typography variant="h3" component="h1" className={classes.title}>
                    {t('contact_us')}
                </Typography>

                <Grid container spacing={4}>
                    <Grid item xs={12} md={4}>
                        <Paper className={classes.paper}>
                            <Box className={classes.contactInfo}>
                                <Typography variant="h6" gutterBottom>
                                    {t('contact_info')}
                                </Typography>
                                
                                <Box className={classes.contactItem}>
                                    <EmailIcon className={classes.contactIcon} />
                                    <Typography>
                                        <a href="mailto:hola@agendia.mx">hola@agendia.mx</a>
                                    </Typography>
                                </Box>

                                <Box className={classes.contactItem}>
                                    <PhoneIcon className={classes.contactIcon} />
                                    <Typography>
                                        <a href="tel:+524426798891">+52 (442) 679-8891</a>
                                    </Typography>
                                </Box>

                                <Box className={classes.contactItem}>
                                    <LocationOnIcon className={classes.contactIcon} />
                                    <Typography>
                                        {t('company_address')}
                                    </Typography>
                                </Box>
                            </Box>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default connect()(ContactUs); 